import {Component, Input, OnInit, TemplateRef, ViewChild, Output, EventEmitter} from '@angular/core';
import {NgbModal, NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ToastrService} from "ngx-toastr";
import {FlatpickrOptions} from "ng2-flatpickr";
import {TresorerieService } from '../../../../../services/tresorerie/tresorerie.service';
import {Tresorerie} from '../../../../../models/Tresorerie/Tresorerie';
import {CategorieTresorerie} from '../../../../../models/Tresorerie/CategorieTresorerie';

@Component({
  selector: 'app-save',
  templateUrl: './save.component.html',
  styleUrls: ['./save.component.scss']
})
export class SaveComponent implements OnInit {
    @Input() data: any = null;
    @Input() soldeType: string = 'secondaire';
    @Output() operationCreated = new EventEmitter<void>();
    @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
    
    productData: any = {
        type: ''
    };
    
    formData: any = {
        montant: '',
        date_reglement: '',
        categorie: '',
        methode_paiement: '',
        note: ''
    };
    
    categories: CategorieTresorerie[] = [];
    stationId: number = 0;
    userId: number = 0;
    isLoading = false;
    private modalRef!: NgbModalRef;

    constructor(
        private modalService: NgbModal,
        private toastr: ToastrService,
        private tresorerieService: TresorerieService
    ) {}

    ngOnInit(): void {
        this.loadUserData();
        this.loadCategories();
    }

    private loadUserData(): void {
        try {
            const userJson = localStorage.getItem('currentUser');
            if (userJson) {
                const user = JSON.parse(userJson);
                this.userId = user?.id || 0;
                const station = user?.stations?.[0];
                this.stationId = station?.id ? Number(station.id) : 0;
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des données utilisateur:', error);
        }
    }

    private loadCategories(): void {
        if (!this.stationId) {
            return;
        }
        this.tresorerieService.getCategories(this.stationId).subscribe({
            next: (list: CategorieTresorerie[]) => {
                this.categories = Array.isArray(list) ? list : [];
            },
            error: () => {
                this.toastr.error('Erreur lors du chargement des catégories.', 'Erreur');
            }
        });
    }

    public basicDateOptions: FlatpickrOptions = {
        altInput: true,
        dateFormat: 'Y-m-d',
        defaultDate: new Date()
    };

    openModal() {
        this.resetForm();
        // Recharger les catégories à l'ouverture du modal pour s'assurer qu'elles sont à jour
        this.loadCategories();
        const options: NgbModalOptions = {
            centered: true,
            backdrop: 'static',
            keyboard: true,
            size: 'lg',
        };
        this.modalRef = this.modalService.open(this.modalTemplate, options);
    }

    private resetForm() {
        this.productData = {
            type: ''
        };
        this.formData = {
            montant: '',
            date_reglement: new Date().toISOString().split('T')[0],
            categorie: '',
            methode_paiement: '',
            note: ''
        };
    }

    confirmOperation() {
        if (!this.validateForm()) {
            return;
        }

        this.isLoading = true;
        
        const operation: Tresorerie = {
            date_operation: this.formData.date_reglement || new Date().toISOString().split('T')[0],
            type_operation: this.productData.type === 'debit' ? 'depense' : 'recette',
            type_paiement: this.productData.type,
            montant: this.formData.montant.toString(),
            montant_ttc: this.formData.montant.toString(),
            methode_paiement: this.formData.methode_paiement,
            categorie_id: this.formData.categorie ? parseInt(this.formData.categorie) : null,
            note: this.formData.note || null,
            description: this.formData.note || null,
            solde_type: this.soldeType,
            user_id: this.userId,
            station_id: this.stationId,
            statut: 'actif',
            document_id: null,
            paiement_id: null
        };

        this.tresorerieService.createTresorerie(operation).subscribe({
            next: (result) => {
                this.toastr.success('Opération enregistrée avec succès.', 'Succès');
                this.modalRef.close();
                this.operationCreated.emit();
                this.isLoading = false;
            },
            error: (error) => {
                console.error('Erreur lors de la création de l\'opération:', error);
                this.toastr.error('Erreur lors de l\'enregistrement de l\'opération.', 'Erreur');
                this.isLoading = false;
            }
        });
    }

    private validateForm(): boolean {
        if (!this.formData.montant || parseFloat(this.formData.montant) <= 0) {
            this.toastr.error('Le montant est requis et doit être supérieur à 0.', 'Erreur');
            return false;
        }
        if (!this.formData.date_reglement) {
            this.toastr.error('La date de règlement est requise.', 'Erreur');
            return false;
        }
        if (!this.productData.type) {
            this.toastr.error('Le type de paiement est requis.', 'Erreur');
            return false;
        }
        if (!this.formData.methode_paiement) {
            this.toastr.error('La méthode de paiement est requise.', 'Erreur');
            return false;
        }
        return true;
    }
}
